import { css } from "@emotion/react";

export const wrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem auto 0;
  list-style: none;
`;
